import { render } from "./headerTabs.vue?vue&type=template&id=7ef41d80&scoped=true"
import script from "./headerTabs.vue?vue&type=script&lang=js"
export * from "./headerTabs.vue?vue&type=script&lang=js"

import "./headerTabs.vue?vue&type=style&index=0&id=7ef41d80&scoped=true&lang=css"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef41d80"]])

export default __exports__